import { RootState } from "@app/redux/root-reducer";

export const selectCarValuationState = (store: RootState) =>
  store.carValuationReducers.carValuation;
